import {useEffect,useState} from 'react'
import { useEntityCrud } from '../../hooks/useEntityCrud'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'

const Index = () => {

    const [currentRowId,setCurrentRowId] = useState(0)
    const [rows,setRows] = useState([])
    const {readData} = useEntityCrud('ReIssue/getReIssueRules')
    const {addData: disableRow} = useEntityCrud(`ReIssue/changeRulesStatus?id=${currentRowId}`)

    const getData = () => {
        readData().then(({data}) => {
            if(data.status)
                setRows(data.result)
        })
    }
    
    useEffect(() => {
        getData()
    },[])

    useEffect(() => {
        if(currentRowId)
            disableRow().then(({data}) => {
                if(data.status){
                    toast.success('قانون با موفقیت غیرفعال شد')
                    getData()
                }else
                    data.errors.map(err => toast.error(err.message))
            })
    },[currentRowId])

    const disable = id => {
        setCurrentRowId(id)
    }

    return (
        <div className="card">
            <div className="card-header px-4">
                <div className="card-title">قوانین صدور مجدد</div>
            </div>
            <div className="card-body p-4">
                <Link to="create" className="btn btn-success">ایجاد قانون جدید</Link>
                <hr />
                {rows.length ? <div className="table-responsive">
                    <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>عنوان</th>
                                <th>دفعات درخواست</th>
                                <th>هزینه صدور</th>
                                <th>مدت زمان صدور</th>
                                <th>وضعیت</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row,index) => <tr key={row.id}>
                                <td>{++index}</td>
                                <td>{row.title}</td>
                                <td>{row.issueTimes}</td>
                                <td>{row.issuePrice ? new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(row.issuePrice) : ''}</td>
                                <td>{row.issuePreparationTime}</td>
                                <td>{row.isActive ? <span className="badge bg-success">فعال</span> : <span className="badge bg-danger">غیرفعال</span>}</td>
                                <td>
                                    <Link className="btn btn-primary btn-icon" to={`update/${row.id}`}><i className="fe fe-edit-2"></i></Link>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                    <p>تعداد کل ردیف ها : {rows.length || 0}</p>
                </div> : <div className="alert alert-info mb-0"><p className="mb-0">قانونی در سیستم ثبت نشده است</p></div>}
            </div>
        </div>
    )
}

export default Index